import React, { FC, ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useUser } from '~/stores/use-user/useUser';

import { appPaths, queryKeys } from '../../routes/app-paths';

interface AppHistoryProps {
  children: ReactNode;
}

export const AppHistory: FC<AppHistoryProps> = props => {
  const { user } = useUser(({ user }) => ({ user }));
  const location = useLocation();
  const navigate = useNavigate();
  const { trackDashboardOpen } = usePosthogEvents();

  useEffect(() => {
    if (user) {
      const queryParams = new URLSearchParams(location.search);
      const redirectTo = queryParams.get(queryKeys.redirect);

      if (redirectTo) {
        const isRedirectToDashboard = redirectTo === appPaths.base;

        if (isRedirectToDashboard) {
          trackDashboardOpen('login');
        }

        navigate(redirectTo, { replace: true });
        return;
      }
    }
  }, [location, user, navigate]);

  return <>{props.children}</>;
};
